// src/pages/Offers.js
import React from "react";
import "../styles/Offers.css";
import OfferCard from "../components/OfferCard"; // Import OfferCard component
import offersData from "../data/offersData";

const Offers = () => {
  return (
    <div className="offers-page container">
      <h2>🎉 Current Offers</h2>
      <p className="offers-intro">Grab the hottest deals this festive season!</p>

      <div className="offers-grid">
        {offersData.offerData.map((offer, index) => (
          <OfferCard key={index} offer={offer} phoneNumber={offersData.contact.phoneNumber} />
        ))}
      </div>
    </div>
  );
};

export default Offers;
